import React from 'react';
const kennitala = require('kennitala')
import { fetchCustomer, addEmptyCustomer } from '../../api/customers/actions'
import { formatKennitala, summarizeOfferCheckboxes } from '../../utils'
import connectWithStore from '../../utils/store'
import CustomerLookup from '../customer-lookup'
import { store } from '../../store'
import ContractsOverview from '../../components/contracts-overview'
import AdminFunctions from '../../components/admin-functions'
import TilbodNavigation from '../tilbod-navigation'
import { setStale } from '../../api/offers/actions'
import { isUserAdmin } from '../../api/brokers/actions';
import { fetchJobs } from '../../api/jobs/actions';
import DOMPurify from 'dompurify';


class TilbodStepOne extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount(){
      this.props.dispatch(setStale(true))
      this.props.dispatch(isUserAdmin())
      this.props.dispatch(fetchJobs())
    }

    render() {
        let customers = this.props.customers;


        return (
            <>
                <div className="header hero">
                    <div className="container">
                        { this.props.message  &&
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10 col-sm-12">
                                    <div className="alert alert-warning" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.message) }}>  
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <CustomerLookup allowCompanies={this.props.admins && this.props.admins.data} />
                            </div>
                        </div>
                    </div>
                </div>

                <ContractsOverview dispatch={this.props.dispatch} customers={this.props.customers} offers={this.props.offers} contracts={this.props.contracts} admins={this.props.admins} />


                <TilbodNavigation />
            </>
        )
    }
}

TilbodStepOne.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        contracts: {},
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        admins: {}
    }
    f.contracts = (state.contracts === undefined) ? {} : state.contracts
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.admins = (state.admins === undefined) ? {} : state.admins
    return f;
}

export default connectWithStore(store, TilbodStepOne, mapStateToProps);
